export default {
  release: '19.2',
  date: 'July 2026',
  releasePostUrl: 'https://docs.gitlab.com/releases/19/gitlab-19-2-released/',
  contributors: [
    {
      name: 'Vivek Shukla',
      gitlabUsername: 'vivekshukl007',
      linkedIn: 'https://www.linkedin.com/in/vivek-shukla-088a71129',
    },
  ],
  writeUp: `We are excited to recognize Vivek Shukla, a Senior Data Engineer at Emirates, who made high-impact contributions to GitLab Orbit. Vivek's contributions added Scala language support in two phases: first by introducing support for Scala definitions](https://gitlab.com/gitlab-org/orbit/knowledge-graph/-/merge_requests/1903), and then by extending that work to [imports and cross-file references](https://gitlab.com/gitlab-org/orbit/knowledge-graph/-/merge_requests/1933). This work enables Scala repositories to produce code graph definitions for classes, traits, objects, functions, and value bindings, helping GitLab Duo better understand Scala codebases.

Vivek's contribution stands out for both technical depth and relevance to GitLab 19.2. The MR included unit tests and end-to-end verification. [Amr Zaher](https://gitlab.com/azaher2), a GitLab Senior Customer Success Architect, praised the thoroughness of the work and highlighted the care shown in the implementation and testing.

Thank you, Vivek, for helping make GitLab Duo and Orbit more useful for Scala teams and for co-creating GitLab in the open.`,
};
